module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.7.8-137.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.7.8.md
// module id = 554
// module chunks = 237